import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-hourglas-03',
  templateUrl: './hourglas-03.html',
  styleUrl: './hourglas-03.scss',
})
export class Hourglas03 {
  stroke = input<string>('#797674');
  width = input<string>('1rem');
  height = input<string>('1rem');
}
